import { render, staticRenderFns } from "./baozhiqi.vue?vue&type=template&id=44c4b018&scoped=true&"
import script from "./baozhiqi.vue?vue&type=script&lang=js&"
export * from "./baozhiqi.vue?vue&type=script&lang=js&"
import style0 from "./baozhiqi.vue?vue&type=style&index=0&id=44c4b018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4b018",
  null
  
)

export default component.exports